// ── Lógica de cálculo DDP — basada en MATERIALES_OBRA.xlsx ───────────────────
//
// FÓRMULA COMPLETA (por unidad):
//
// PARTE A — ADUANA
//   FOB_flete_decl   = flete_declarado_total × (cbm_unit / cbm_contenedor)
//   FOB_base         = fob_real_unit + FOB_flete_decl
//   Maury            = 5% × FOB_base
//   Derechos         = arancel% × FOB_base
//   Estadística      = 3% × FOB_base
//   Seguro           = 1% × fob_real_unit
//   Suma_aduana      = FOB_base + Maury + Derechos + Estadística + Seguro
//
// PARTE B — LOGÍSTICA (proporcional a CBM del contenedor)
//   Flete_real_unit  = (flete_real_total  / cbm_cont) × cbm_unit
//   Terminal_unit    = (terminal_total    / cbm_cont) × cbm_unit
//   Despachante_unit = (despachante_total / cbm_cont) × cbm_unit
//   Descarga_unit    = (descarga_ars      / cbm_cont) × cbm_unit / TC
//   Transporte_unit  = (transporte_ars    / cbm_cont) × cbm_unit / TC
//   Suma_B           = suma de todo lo anterior
//
// IMPUESTOS (sobre Suma_aduana)
//   IVA 21%  → recuperable para responsables inscriptos
//   IVA2 20% → no recuperable
//   IIBB 4%  → no recuperable
//
// TOTALES
//   costo_total_unit = Suma_aduana + Suma_B + IVA + IVA2 + IIBB
//   costo_neto_unit  = Suma_aduana + Suma_B + IVA2 + IIBB (sin IVA 21% recuperable)

export const NCM_POR_RUBRO = {
  "Sanitarios":      { ncm:"6910.90.00.610V", arancel:0.18,  desc:"Sanitario inodoro y bidet" },
  "Bañeras":         { ncm:"7610.10.00.100Q", arancel:0.16,  desc:"Receptáculo de ducha y bañadera" },
  "Vanitorys":       { ncm:"9403.40.00.100",  arancel:0.18,  desc:"Mueble vanitory de baño" },
  "Pisos SPC":       { ncm:"3918.10.00.110B", arancel:0.16,  desc:"Piso rígido SPC/WPC" },
  "Hornos y Anafes": { ncm:"SIN POSICIÓN",    arancel:0.20,  desc:"Horno empotrable y anafe eléctrico" },
  "Puertas":         { ncm:"3925.20.00.000X", arancel:0.18,  desc:"Puerta WPC" },
  "Carpintería":     { ncm:"7610.10.00.100Q", arancel:0.16,  desc:"Carpintería de aluminio" },
  "Cocinas":         { ncm:"9403.40.00.100",  arancel:0.18,  desc:"Muebles de cocina" },
  "Porcelanato":     { ncm:"6907.30.00.900G", arancel:0.126, desc:"Piso cerámico esmaltado" },
};

export function getNcmPorRubro(rubro) {
  return NCM_POR_RUBRO[rubro] || { ncm:"—", arancel:0.18, desc:"Sin posición definida" };
}

export const CBM_REFERENCIA = {
  "Sanitarios":      { cbm:0.147, desc:"por unidad (inodoro)" },
  "Bañeras":         { cbm:0.36,  desc:"por unidad" },
  "Vanitorys":       { cbm:0.25,  desc:"por unidad estimado" },
  "Pisos SPC":       { cbm:0.01,  desc:"por m²" },
  "Hornos y Anafes": { cbm:0.12,  desc:"por unidad empotrable" },
  "Puertas":         { cbm:0.18,  desc:"por unidad 205×80" },
  "Carpintería":     { cbm:0.15,  desc:"por m² estimado" },
  "Cocinas":         { cbm:0.50,  desc:"por módulo estimado" },
  "Porcelanato":     { cbm:0.012, desc:"por m² (10mm)" },
};

export const GLOBALES_DEFAULT = {
  tipo_cambio:        1500,
  tipo_cambio_blue:   1500,
  cbm_max:            68,
  tipo_contenedor:    "40HQ",
  flete_declarado:    2500,
  flete_real:         5000,
  terminal:           1500,
  despachante:        1000,
  descarga_ars:       300000,
  transporte_ars:     1000000,
  maury_pct:          0.05,
  estadistica_pct:    0.03,
  iva_pct:            0.21,
  iva2_pct:           0.20,
  iibb_pct:           0.04,
  seguro_pct:         0.01,
  certificaciones_pct:0,
};

export function calcImportacion({ fob_compra, fob_declarado, cbm, qty=1, globales, rubro }) {
  const g   = { ...GLOBALES_DEFAULT, ...(globales || {}) };
  const tc  = parseFloat(g.tipo_cambio) || 1500;
  const ncm = getNcmPorRubro(rubro);

  const fob_real_unit  = parseFloat(fob_compra)                   || 0;
  const fob_decl_unit  = parseFloat(fob_declarado || fob_compra)  || 0;
  const cbm_unit       = parseFloat(cbm)                          || 0;
  const cbm_cont       = parseFloat(g.cbm_max)                    || 68;

  // PARTE A — ADUANA
  const prop_cbm       = cbm_cont > 0 ? cbm_unit / cbm_cont : 0;
  const fob_flete_decl = parseFloat(g.flete_declarado) * prop_cbm;
  // Base declarada — SOLO para calcular impuestos aduaneros (Maury, Derechos, Estadística),
  // que legalmente se calculan sobre el valor declarado en aduana. No cambiar: de esto depende
  // también la calculadora de flete que ve el comprador (usa suma_aduana / costo_total_unit).
  const fob_base       = fob_decl_unit + fob_flete_decl;
  const maury          = parseFloat(g.maury_pct)        * fob_base;
  const derechos       = ncm.arancel                    * fob_base;
  const estadistica    = parseFloat(g.estadistica_pct)  * fob_base;
  const seguro         = parseFloat(g.seguro_pct)       * fob_real_unit;
  const certificaciones= parseFloat(g.certificaciones_pct || 0) * fob_base;
  const suma_aduana    = fob_base + maury + derechos + estadistica + seguro + certificaciones;
  // Base real — usa el FOB Compra REAL (lo que efectivamente se paga al proveedor) en vez del
  // declarado. Uso INTERNO únicamente (margen y precio sugerido en el admin) — no se expone
  // al comprador ni reemplaza suma_aduana/costo_total_unit/costo_neto_unit de arriba.
  const suma_aduana_real = fob_real_unit + fob_flete_decl + maury + derechos + estadistica + seguro + certificaciones;

  // PARTE B — LOGÍSTICA
  const flete_real_unit   = parseFloat(g.flete_real)    * prop_cbm;
  const terminal_unit     = parseFloat(g.terminal)      * prop_cbm;
  const despachante_unit  = parseFloat(g.despachante)   * prop_cbm;
  const descarga_unit     = tc > 0 ? (parseFloat(g.descarga_ars)   * prop_cbm) / tc : 0;
  const transporte_unit   = tc > 0 ? (parseFloat(g.transporte_ars) * prop_cbm) / tc : 0;
  const suma_b            = flete_real_unit + terminal_unit + despachante_unit + descarga_unit + transporte_unit;

  // IMPUESTOS
  const iva   = parseFloat(g.iva_pct)  * suma_aduana;
  const iva2  = parseFloat(g.iva2_pct) * suma_aduana;
  const iibb  = parseFloat(g.iibb_pct) * suma_aduana;

  // TOTALES
  const costo_total_unit = suma_aduana + suma_b + iva + iva2 + iibb;
  const costo_neto_unit  = suma_aduana + suma_b + iva2 + iibb; // sin IVA recuperable

  const costo_total_ars  = costo_total_unit * tc;
  const costo_neto_ars   = costo_neto_unit  * tc;

  // TOTALES INTERNOS (base FOB real) — para margen y precio sugerido en el admin.
  // Los impuestos (iva/iva2/iibb) ya están calculados sobre suma_aduana (declarada) arriba;
  // acá solo reemplazamos la base de costo por la real, el % de impuestos aplicado es el mismo.
  const costo_total_interno = suma_aduana_real + suma_b + iva + iva2 + iibb;
  const costo_neto_interno  = suma_aduana_real + suma_b + iva2 + iibb;

  // COSTO PURO (real, sin IVA/IVA2/IIBB) — base de rentabilidad interna.
  // Es la suma de todos los gastos reales (FOB real + flete + derechos + logística)
  // SIN ningún impuesto. "costo_puro_real_con_iva" solo suma el 21% de IVA, nada más.
  const costo_puro_real          = suma_aduana_real + suma_b;
  const costo_puro_real_con_iva  = costo_puro_real * (1 + (parseFloat(g.iva_pct) || 0));

  const desglose = [
    { label:"FOB Compra China",          valor:fob_real_unit },
    { label:"Flete declarado proporcional",valor:fob_flete_decl },
    { label:"Maury 5%",                  valor:maury },
    { label:`Derechos ${(ncm.arancel*100).toFixed(1)}%`, valor:derechos },
    { label:"Estadística 3%",            valor:estadistica },
    { label:"Seguro 1%",                 valor:seguro },
    { label:"Flete real proporcional",   valor:flete_real_unit },
    { label:"Terminal proporcional",     valor:terminal_unit },
    { label:"Despachante proporcional",  valor:despachante_unit },
    { label:"Descarga proporcional",     valor:descarga_unit },
    { label:"Transporte proporcional",   valor:transporte_unit },
    { label:"IVA 21%",                   valor:iva,  tag:"RECUP." },
    { label:"IVA 2 20%",                 valor:iva2 },
    { label:"IIBB 4%",                   valor:iibb },
  ];

  return {
    fob_real_unit, fob_decl_unit, cbm_unit,
    suma_aduana, suma_b, iva, iva2, iibb,
    costo_total_unit, costo_neto_unit,
    costo_total_ars,  costo_neto_ars,
    // Internos — solo para uso en el admin (margen/precio sugerido), no exponer al comprador.
    suma_aduana_real, costo_total_interno, costo_neto_interno,
    costo_puro_real, costo_puro_real_con_iva,
    pct_contenedor: prop_cbm,
    ncm: ncm.ncm, arancel: ncm.arancel,
    desglose,
  };
}

export function calcVenta(costo_neto_unit, precio_venta, tc) {
  if (!costo_neto_unit || !precio_venta) return null;
  const pv   = parseFloat(precio_venta);
  const cn   = parseFloat(costo_neto_unit);
  const tcv  = parseFloat(tc) || 1500;
  const precio_con_iva     = pv * 1.21;
  const ganancia_usd       = pv - cn;
  const margen_pct         = pv > 0 ? ganancia_usd / pv : 0;
  const markup_pct         = cn > 0 ? ganancia_usd / cn : 0;
  return {
    precio_sin_iva:      pv,
    precio_con_iva,
    precio_sin_iva_ars:  pv  * tcv,
    precio_con_iva_ars:  precio_con_iva * tcv,
    ganancia_usd,
    margen_pct,
    markup_pct,
  };
}

export function precioSugerido(costo_neto_unit, margen=0.40) {
  if (!costo_neto_unit || margen >= 1) return 0;
  return parseFloat(costo_neto_unit) / (1 - margen);
}

export function analisisVsMercado(precio_ml_ars, costo_neto_unit, tc) {
  const ml_ars            = parseFloat(precio_ml_ars)    || 0;
  const cn                = parseFloat(costo_neto_unit)  || 0;
  const tcv               = parseFloat(tc)               || 1500;
  const precio_ml_sin_iva = ml_ars / (tcv * 1.21);
  const ganancia          = precio_ml_sin_iva - cn;
  const margen            = precio_ml_sin_iva > 0 ? ganancia / precio_ml_sin_iva : 0;
  return { precio_ml_ars:ml_ars, precio_ml_sin_iva, ganancia, margen };
}

export const fmtUSD = v => v==null ? "—" : `USD ${parseFloat(v).toLocaleString("es-AR",{minimumFractionDigits:2,maximumFractionDigits:2})}`;
export const fmtARS = v => v==null ? "—" : `$ ${parseFloat(v).toLocaleString("es-AR",{minimumFractionDigits:0,maximumFractionDigits:0})}`;
export const fmtPct = v => v==null ? "—" : `${(parseFloat(v)*100).toFixed(1)}%`;

// Alias para compatibilidad con imports anteriores
export const calcMargen = calcVenta;
export const calcDDP = calcImportacion;
